import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { TableShiftPlanningCellProp } from '../shift-planning-table.types';

export const MultiDayShiftJobNameCell = (props: TableShiftPlanningCellProp<'jobName'>) => {
  const { t } = useTranslation('ogp-screen-specific');
  const row = props.row.original;

  if (
    row.multiDayShiftId == null ||
    row.multiDayShiftDayIndex == null ||
    row.multiDayShiftDayCount == null
  ) {
    return (
      <Tooltip title={props.value}>
        <Typography variant="body1" noWrap>
          {props.value}
        </Typography>
      </Tooltip>
    );
  }

  const indicatorLabel = t('planning.multi_day_shift.day_indicator', {
    current: row.multiDayShiftDayIndex + 1,
    total: row.multiDayShiftDayCount,
  });

  return (
    <Tooltip title={`${indicatorLabel} – ${props.value}`}>
      <MultiDayShiftIndicatorBox>
        <MultiDayShiftIndicatorLabel variant="caption" data-testid="multi-day-shift-indicator">
          {indicatorLabel}
        </MultiDayShiftIndicatorLabel>
        <Typography variant="body1" noWrap>
          {props.value}
        </Typography>
      </MultiDayShiftIndicatorBox>
    </Tooltip>
  );
};

const MultiDayShiftIndicatorBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

const MultiDayShiftIndicatorLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.lwPrimaryAccentDark[100],
  fontWeight: 600,
}));
